<template>
  <div class="title-wrap">
    <!-- 文字标题 -->
    <div class="text-title" v-if="titleType === 1 || titleType === '1'">
      <div class="push-title" ref="mainTitle">
        {{ titleObj && titleObj.title }}
      </div>
    </div>
    <!-- 图片标题 -->
    <div class="img-title" v-else-if="titleType === 2 || titleType === '2'">
      <div class="title-image-wrap">
        <img class="title-image" :src="titleObj && titleObj.title_image" alt />
      </div>
    </div>
    <!-- 图文标题 -->
    <div class="mix-title" v-else>
      <img class="title-image" :src="titleObj && titleObj.title_image" alt />
      <div class="mix-title-text">{{ titleObj && titleObj.title }}</div>
    </div>
    <!-- 发布人、发布时间、阅读量 -->
    <div
      :class="{
        paddinglr: titleType == 1,
        paddingwrap: titleType == 2 || titleType == 3,
      }"
      class="sub-title"
      ref="subTitle"
    >
      <div
        class="left-wrap"
        :style="{ 'margin-right': `${os.android ? '0.18rem' : '0'}` }"
      >
        <span
          class="title_icon"
          @click="goEarlyWarningLink"
          :style="{ backgroundImage: `url(${titleObj.min_image})` }"
          v-if="titleObj.min_image"
        ></span>
        <span
          @click="goEarlyWarningLink"
          class="title-text"
          :class="{ 'has-min-image': titleObj.min_image }"
          >{{ titleObj && titleObj.push_user }}</span
        >
        <span class="public-time">{{
          formatPublicTime(titleObj && titleObj.push_time)
        }}</span>
      </div>
      <div class="view-info" v-if="titleObj && titleObj.viewed_count">
        <div class="icon"></div>
        <div class="view-info-text">
          {{ checkPreviewNum(titleObj && titleObj.viewed_count) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { os, webviewInfo, log } from '@ali/amap-lib';
import jumpHandler from '../../../common/js/jump-handler';

export default {
  props: ['titleType', 'titleObj', 'logParams'],
  data() {
    return {
      os
    };
  },
  mounted() {
    console.log(this.titleObj);
  },
  methods: {
    // 跳转交通号首页
    goEarlyWarningLink() {
      const { min_image: minImage } = this.titleObj;
      if (!minImage) return;
      const { pageType, type, unitId } = this.logParams;
      log.log('author_click', { page_type: pageType, type, album_id: unitId });
      // this.$router.push({ name: 'EarlyWarning' });
      const url = new URL('https://jiaotonghao2.amap.com?channel=amap&src=h5_lbp_push');
      const { searchParams } = url;
      searchParams.append('unitId', unitId);
      jumpHandler(url, { needSchema: !!webviewInfo.isInAmap(), hideTitleBar: true });
    },
    // 阅读量判断
    checkPreviewNum(num) {
      if (!num || Number(num) === 0) {
        return 0;
      }
      return Number(num) > 9999 ? `${Math.floor(num / 1000) / 10}万` : num;
    },
    // 格式化发布时间
    formatPublicTime(time) {
      time = (time && time.replace(/-/g, '/')) || ''; // ios端不支持 2019-1-1 格式，可替换成 2019/1/1 格式
      const tempM = (new Date(time)).getMonth() + 1;
      const tempD = (new Date(time)).getDate();
      const m = tempM < 10 ? `0${tempM}` : tempM;
      const d = tempD < 10 ? `0${tempD}` : tempD;
      return `${m}月${d}日`;
    }
  }
};
</script>

<style lang="scss">
@import "../css/index";
@import "../../../common/css/common-mixin";
.title-wrap {
  margin-bottom: rpx(32);
  .sub-title {
    display: flex;
    align-items: center;
    width: 100%;
    height: rpx(100);
    // white-space:pre-wrap;
    &.paddinglr {
      padding: 0 0.4rem;
    }
    &.paddingwrap {
      padding: 0 0.4rem;
      padding-bottom: 0;
    }
    .left-wrap {
      display: flex;
      flex-direction: row;
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      align-items: center;
    }
    .title-text {
      color: #757575;
      font-size: rpx(28);
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      &.has-min-image {
        color: #4287ff;
      }
    }
    .title_icon {
      display: inline-block;
      width: rpx(40);
      height: rpx(40);
      margin-right: rpx(10);
      background: no-repeat center center/contain;
    }
    .public-time {
      margin: 0 rpx(20);
      font-size: rpx(28);
      color: #757575;
    }
    .view-info {
      display: flex;
      align-items: center;
      // padding-left: rpx(34);
      .icon {
        width: rpx(28);
        height: rpx(30);
        background: url(../../../assets/img/eye.png) no-repeat center
          center/contain;
        background-size: rpx(24) rpx(14);
        margin-right: rpx(10);
      }
      .view-info-text {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: rpx(28);
        color: #757575;
        // letter-spacing: 0.49px;
        // &::before {
        //   content: '';
        //   position: absolute;
        //   left: rpx(-32);
        //   top: 0;
        //   width: rpx(28);
        //   height: 100%;
        //   background: url(../../../assets/img/eye.png) no-repeat center center;
        //   background-size: rpx(24) rpx(14);
        //   margin-right: rpx(6);
        // }
      }
    }
  }
  .text-title {
    padding: rpx(32) rpx(40);
    .push-title {
      display: -webkit-box;
      font-weight: 600;
      font-size: rpx(48);
      line-height: rpx(67);
      color: #212121;
      // text-align: justify;
      // padding-top: rpx(32);
      // padding-bottom: rpx(32);
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      overflow: hidden;
    }
  }
  .img-title {
    height: rpx(300);
    .title-image-wrap {
      height: rpx(300);
      overflow: hidden;
      margin-bottom: rpx(20);
      .title-image {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: auto;
      }
    }
  }
  .mix-title {
    height: rpx(370);
    overflow: hidden;
    .title-image {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      height: auto;
      margin-bottom: rpx(20);
    }
    .mix-title-text {
      width: 100%;
      padding: 0 rpx(60);
      text-align: center;
      font-weight: bold;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 24px;
      line-height: 1.4;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      overflow: hidden;
    }
    .text-padding {
      padding: 0 rpx(40);
    }
  }
}
</style>
